import { db, type LocalRate } from '../db';
import axiosInstance from '../api/axios';
import { getSelectedSede } from './sede';

export const syncRatesToLocal = async (companyId: string) => {
    try {
        const response = await axiosInstance.get('/rates');
        // Multi sede: la caché offline guarda solo las tarifas de la sede activa
        const sedeId = getSelectedSede();
        const rates: any[] = response.data.filter((rate: any) => !sedeId || !rate.sedeId || rate.sedeId === sedeId);

        // Clear existing rates for this company
        await db.rates.where({ companyId }).delete();

        // Insert new rates
        const localRates: LocalRate[] = rates.map(rate => ({
            id: rate.id,
            tipoVehiculo: rate.tipoVehiculo,
            tarifaBase: rate.tarifaBase,
            minutosGratis: rate.minutosGratis,
            fraccionMinutos: rate.fraccionMinutos,
            valorFraccion: rate.valorFraccion,
            tarifaMaximaDia: rate.tarifaMaximaDia,
            companyId: rate.companyId,
            updatedAt: new Date().toISOString()
        }));

        await db.rates.bulkAdd(localRates);
        console.log(`✅ Synced ${localRates.length} rates to IndexedDB`);
        return true;
    } catch (error) {
        console.error('Error syncing rates:', error);
        return false;
    }
};
